export default class RxUtils {
  static rxToObject(rxObject) {
    return JSON.parse(JSON.stringify(rxObject))
  }
}